import { memo as Memo, useEffect, useMemo, useRef } from 'react';
import { TimelineLite } from 'gsap';

const InputLine = Memo(({ animate }) => {
	//! Refs
	const ref = useRef();

	//! Animation
	const tl = useMemo(() => new TimelineLite({ paused: true }), []);

	useEffect(() => {
		if (ref.current) {
			if (animate) {
				tl.to(ref.current, 0.8, { xPercent: 66 }).play();
			} else {
				tl.to(ref.current, 0, { xPercent: 0 });
			}
		}
	}, [animate, tl, ref]);

	return (
		<svg
			ref={ref}
			className={'input-line-svg-styles'}
			width='300%'
			height='100%'
			viewBox='0 0 1200 60'
			preserveAspectRatio='none'>
			<path d='M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0' />
		</svg>
	);
});

export default InputLine;
